import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function QcPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('qcH1')} | CSSBuy Spreadsheet`;
  }, [t]);

  const steps = [
    { icon: 'ri-image-line', title: t('qcStep1'), desc: 'Examine todas as fotos QC fornecidas. Verifique ângulos diferentes e detalhes de perto.' },
    { icon: 'ri-eye-line', title: t('qcStep2'), desc: 'Compare as fotos QC com as imagens do vendedor. Identifique diferenças visíveis.' },
    { icon: 'ri-scissors-line', title: t('qcStep3'), desc: 'Inspecione a qualidade das costuras, materiais e acabamento geral do produto.' },
    { icon: 'ri-price-tag-3-line', title: t('qcStep4'), desc: 'Verifique se logos, etiquetas e marcações estão corretas e bem posicionadas.' },
    { icon: 'ri-ruler-line', title: t('qcStep5'), desc: 'Confirme as medidas e tamanhos. Compare com a tabela de medidas do vendedor.' },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <div className="max-w-6xl mx-auto px-4 md:px-6 pt-24 pb-4">
          <nav className="flex items-center gap-2 text-sm text-foreground-500">
            <Link to="/" className="hover:text-primary-600 transition-colors">{t('breadcrumbHome')}</Link>
            <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
            <span className="text-foreground-700">QC</span>
          </nav>
        </div>

        <section className="py-8 md:py-12">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <h1 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-6">
              {t('qcH1')}
            </h1>
            <p className="text-lg text-foreground-700 leading-relaxed mb-10 max-w-3xl">
              {t('qcIntro')}
            </p>

            <div className="space-y-4 mb-10">
              {steps.map((step, index) => (
                <div key={index} className="flex gap-4 bg-background-100 rounded-xl p-5">
                  <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center rounded-xl bg-accent-100">
                    <i className={`${step.icon} text-accent-600`} style={{ width: 20, height: 20 }} />
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground-950 mb-1">{step.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 pt-8 border-t border-background-200/70">
              <h3 className="font-semibold text-foreground-950 mb-4">{t('articleRelated')}</h3>
              <div className="flex flex-wrap gap-3">
                <Link to="/cssbuy-spreadsheet" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('breadcrumbSpreadsheet')}</Link>
                <Link to="/cssbuy-shipping" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('navShipping')}</Link>
                <Link to="/cssbuy-safety" className="px-4 py-2 bg-background-100 rounded-lg text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors">{t('navSafety')}</Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}